<script>
  export default {
    name: 'ZmCol',

    props: {
      span: {
        type: Number,
        default: 24
      },
      tag: {
        type: String,
        default: 'div'
      },
      offset: Number,
      pull: Number,
      push: Number,
      xs: [Number, Object],
      sm: [Number, Object],
      md: [Number, Object],
      lg: [Number, Object],
      xl: [Number, Object]
    },

    computed: {
      gutter() {
        return this.row.gutter;
      },
      style() {
        const style = {};
        if (this.gutter) {
          style.paddingLeft = this.gutter / 2 + 'px';
          style.paddingRight = style.paddingLeft;
        }
        return style;
      },
      classList() {
        const classList = ['zm-col'];

        ['span', 'offset', 'pull', 'push'].forEach(prop => {
          if (this[prop] || this[prop] === 0) {
            classList.push(
              prop !== 'span'
                ? `zm-col-${prop}-${this[prop]}`
                : `zm-col-${this[prop]}`
            );
          }
        });

        ['xs', 'sm', 'md', 'lg', 'xl'].forEach(size => {
          if (typeof this[size] === 'number') {
            classList.push(`zm-col-${size}-${this[size]}`);
          } else if (typeof this[size] === 'object') {
            let props = this[size];
            Object.keys(props).forEach(prop => {
              classList.push(
                prop !== 'span'
                  ? `zm-col-${size}-${prop}-${props[prop]}`
                  : `zm-col-${size}-${props[prop]}`
              );
            });
          }
        });

        return classList;
      }
    },

    inject: ['row'],

    render(h) {
      return h(this.tag, {
        class: this.classList,
        style: this.style
      }, this.$slots.default);
    }
  };
</script>

<style lang="scss">
  @import "../../scss/common/var";
  @import "../../scss/mixins/mixins";

  [class*="zm-col-"] {
    float: left;
    box-sizing: border-box;
  }

  .zm-col-0 {
    display: none;
  }

  @for $i from 0 through 24 {
    .zm-col-#{$i} {
      width: (1 / 24 * $i * 100) * 1%;
    }

    .zm-col-offset-#{$i} {
      margin-left: (1 / 24 * $i * 100) * 1%;
    }

    .zm-col-pull-#{$i} {
      position: relative;
      right: (1 / 24 * $i * 100) * 1%;
    }

    .zm-col-push-#{$i} {
      position: relative;
      left: (1 / 24 * $i * 100) * 1%;
    }
  }

  @include res(xs) {
    .zm-col-xs-0 {
      display: none;
    }
    @for $i from 0 through 24 {
      .zm-col-xs-#{$i} {
        width: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-xs-offset-#{$i} {
        margin-left: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-xs-pull-#{$i} {
        position: relative;
        right: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-xs-push-#{$i} {
        position: relative;
        left: (1 / 24 * $i * 100) * 1%;
      }
    }
  }

  @include res(sm) {
    .zm-col-sm-0 {
      display: none;
    }
    @for $i from 0 through 24 {
      .zm-col-sm-#{$i} {
        width: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-sm-offset-#{$i} {
        margin-left: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-sm-pull-#{$i} {
        position: relative;
        right: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-sm-push-#{$i} {
        position: relative;
        left: (1 / 24 * $i * 100) * 1%;
      }
    }
  }

  @include res(md) {
    .zm-col-md-0 {
      display: none;
    }
    @for $i from 0 through 24 {
      .zm-col-md-#{$i} {
        width: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-md-offset-#{$i} {
        margin-left: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-md-pull-#{$i} {
        position: relative;
        right: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-md-push-#{$i} {
        position: relative;
        left: (1 / 24 * $i * 100) * 1%;
      }
    }
  }

  @include res(lg) {
    .zm-col-lg-0 {
      display: none;
    }
    @for $i from 0 through 24 {
      .zm-col-lg-#{$i} {
        width: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-lg-offset-#{$i} {
        margin-left: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-lg-pull-#{$i} {
        position: relative;
        right: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-lg-push-#{$i} {
        position: relative;
        left: (1 / 24 * $i * 100) * 1%;
      }
    }
  }

  @include res(xl) {
    .zm-col-xl-0 {
      display: none;
    }
    @for $i from 0 through 24 {
      .zm-col-xl-#{$i} {
        width: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-xl-offset-#{$i} {
        margin-left: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-xl-pull-#{$i} {
        position: relative;
        right: (1 / 24 * $i * 100) * 1%;
      }

      .zm-col-xl-push-#{$i} {
        position: relative;
        left: (1 / 24 * $i * 100) * 1%;
      }
    }
  }
</style>
